import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import Sheet from 'components/utils/Sheet'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import { useCurrencyFormatter } from 'hooks/useNumberFormatters'

const BannerContainer = styled(Sheet)`
  position: relative;
  border-color: ${props => props.theme.palette.messaging.urgency.normalForeground};
`

const SaleLabel = styled(MessagingLabel)`
  position: absolute;
  top: ${rem(-14)};
  inset-inline-start: ${rem(-1)};
`

interface Props {
  onViewSaleDates: () => void
}

function FlashHotelHundredDollarSaleSummaryBanner({ onViewSaleDates }: Props) {
  const intl = useIntl()
  const formatAudCurrency = useCurrencyFormatter({ currency: 'AUD' })

  return (
    <BannerContainer
      background="normal-background"
      border="critical"
      borderWidth={2}
      borderRadius="M"
      padding="20 16 16"
    >
      <SaleLabel
        variant="urgency"
        startIcon={<SolidFireIcon />}
      >
        {intl.formatMessage({
          id: 'sW8RHHlJM1QGkzhbQFQd',
          defaultMessage: 'Limited Time Sale',
          description: 'Urgency label for the limited-time Maldives charter flight promotion modal',
        })}
      </SaleLabel>

      <Heading variant="heading6">
        {intl.formatMessage(
          {
            id: 'LOUD290xVh0RwkVpDbzO',
            defaultMessage: '100 return economy seats for {fareAmount} each',
            description: 'Offer page summary banner heading for the Maldives charter one hundred dollar return economy seat promotion',
          },
          { fareAmount: formatAudCurrency(100, 'roundedDollar') },
        )}
      </Heading>

      <BodyText variant="medium" colour="neutral-two">
        <FormattedMessage
          id="_zC9Vf7BTe6Lg3y5WPrX"
          defaultMessage="Available as part of our bundled hotel stays, on select dates only. <link>View sale dates</link>"
          description="Offer page summary banner body text explaining sale eligibility with a link to view sale dates"
          values={{
            link: (chunks) => (
              <TextLink
                key="sale-dates-link"
                weight="regular"
                onClick={onViewSaleDates}
              >
                {chunks}
              </TextLink>
            ),
          }}
        />
      </BodyText>
    </BannerContainer>
  )
}

export default FlashHotelHundredDollarSaleSummaryBanner
